import { WebviewManager } from "./webview-manager";

export const webViewFactory = (webViewFactory:WebviewManager) => () => webViewFactory.initWebView()